import { createContext, useContext } from 'react';
import type { MutableRefObject } from 'react';

interface FormRendererContextValue {
  mapRef: MutableRefObject<any>;
  isLoadingSensorData: boolean;
}

const FormRendererContext = createContext<FormRendererContextValue | undefined>(undefined);

export const FormRendererProvider = FormRendererContext.Provider;

export const useFormRendererContext = (): FormRendererContextValue => {
  const ctx = useContext(FormRendererContext);
  if (!ctx) {
    throw new Error('useFormRendererContext must be used within a FormRenderer');
  }
  return ctx;
};
